<template>
<main class="home" v-touch:swipe="onTap">
  <router-link :to="{ name: 'projects' }">
    <div class="container">
      <div ref="line" class="line name">
        <h1>
          <letter letter="E" />
          <letter letter="S" />
          <letter letter="T" />
          <letter letter="E" />
          <letter letter="L" />
          <letter letter="L" />
          <letter letter="E" />
        </h1>
        <h1 ref="word">
          <letter letter="B" />
          <letter letter="O" />
          <letter letter="U" />
          <letter letter="R" />
          <letter letter="D" />
          <letter letter="E" />
          <letter letter="T" />
        </h1>
      </div>
      <div ref="line2" class="line tagline">
        <h1>
          <letter letter="W" />
          <letter letter="E" />
          <letter letter="A" />
          <letter letter="V" />
          <letter letter="I" />
          <letter letter="N" />
          <letter letter="G" />
        </h1>
        <h1 ref="word">
          <letter letter="A" />
          <letter letter="N" />
          <letter letter="D" />
        </h1>
        <h1 ref="word">
          <letter letter="T" />
          <letter letter="E" />
          <letter letter="X" />
          <letter letter="T" />
          <letter letter="I" />
          <letter letter="L" />
          <letter letter="E" />
          <letter letter="S" />
        </h1>
      </div>
    </div>
  </router-link>
</main>
</template>

<script>
import Letter from '@/components/Letter'

export default {
  components: {
    Letter
  },
  methods: {
    onTap() {
      this.$router.push({
        name: 'projects'
      })
    }
  },
  metaInfo: {
    title: 'Estelle Bourdet',
    titleTemplate: null
  }
}
</script>

<style lang="scss" scoped>
.home {
    padding: 0.5em !important;
    position: relative;
    width: 100%;
    height: 100vh !important;
    a {
        display: inline-block;
        width: 100%;
        height: 100%;
        .container {
            position: relative;
            width: 100%;
            height: 100%;
            .line {
                position: absolute;
                top: 50%;
                left: 50%;
                width: 100%;
                text-align: center;
                white-space: nowrap;
                box-sizing: border-box;
                &.name {
                    transform: translate(-50%,-150%);
                }
                &.tagline {
                    transform: translate(-50%,20%);
                }
                @media only screen and (max-width:768px) {
                    width: 100%;
                    &.name {
                        transform: translate(-50%,-150%);
                    }
                    &.tagline {
                        transform: translate(-50%,0%);
                    }
                }
                h1 {
                    font-size: 5.8em;
                    display: inline-block;
                    padding: 0 0.5em;
                    box-sizing: border-box;
                    text-align: center;
                    @media only screen and (max-width:1380px) {
                        font-size: 3.1em;
                    }
                    @media only screen and (max-width:768px) and (orientation: portrait) {
                        height: 2em;
                        display: block;
                        font-size: 2.5em;
                        width: 100%;
                        text-align: center;
                    }
                    span {
                        position: relative;
                        display: inline-block;
                        transition: transform 0.1s;
                    }
                }
            }
        }
    }
}
</style>
